// import React, { useState, useEffect } from "react";
// import { CssVarsProvider } from "@mui/joy/styles";
// import axios from "axios";
// import { format } from "date-fns";
// import {
//   Wallet,
//   Building2,
//   CheckCircle,
//   AlertCircle,
//   Plus,
//   History,
//   X,
//   ArrowUpCircle,
//   ArrowDownCircle,
// } from "lucide-react";
// import Card from "@mui/joy/Card";
// import Button from "@mui/joy/Button";
// import Typography from "@mui/joy/Typography";
// import Input from "@mui/joy/Input";
// import Select from "@mui/joy/Select";
// import Option from "@mui/joy/Option";
// import FormControl from "@mui/joy/FormControl";
// import FormLabel from "@mui/joy/FormLabel";
// import Modal from "@mui/joy/Modal";
// import ModalDialog from "@mui/joy/ModalDialog";
// import Table from "@mui/joy/Table";
// import Alert from "@mui/joy/Alert";

// function CreditPage() {
//   const BASE_URL = process.env.REACT_APP_BASE_URL;
//   const [organizations, setOrganizations] = useState([]);
//   const [projects, setProjects] = useState([]);
//   const [orgBalance, setOrgBalance] = useState(null);
//   const [transactions, setTransactions] = useState([]);
//   const [showTransactions, setShowTransactions] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [success, setSuccess] = useState("");
//   const [responseMessage, setResponseMessage] = useState("");
//   const [responseType, setResponseType] = useState(null);
//   const [showModal, setShowModal] = useState(false);

//   const [formData, setFormData] = useState({
//     amount: "",
//     organization_id: "",
//     project_id: "",
//     user_id: 10,
//   });

//   const fetchOrganizations = async () => {
//     try {
//       const response = await fetch(`${BASE_URL}/orgdetails/getorganizations`);
//       if (!response.ok) throw new Error("Failed to fetch organizations");
//       const data = await response.json();
//       setOrganizations(data);
//     } catch (err) {
//       setError("Failed to fetch organizations");
//       console.error(err);
//     }
//   };

//   const fetchProjects = async (orgId) => {
//     try {
//       const response = await fetch(`${BASE_URL}/orgdetails/projects`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ org_id: orgId }),
//       });
//       if (!response.ok) throw new Error("Failed to fetch projects");
//       const data = await response.json();
//       setProjects(data);
//     } catch (err) {
//       setProjects([]);
//       setError("Failed to fetch projects");
//       console.error(err);
//     }
//   };

//   const fetchOrgBalance = async (orgId) => {
//     try {
//       const response = await axios.get(`${BASE_URL}/points/points/${orgId}`, {
//         withCredentials: true,
//       });
//       setOrgBalance(response.data);
//     } catch (err) {
//       setError("Failed to fetch organization balance");
//       console.error(err);
//     }
//   };

//   const fetchTransactions = async (orgId) => {
//     try {
//       const response = await axios.get(
//         `${BASE_URL}/points/transactions/${orgId}`,
//         {
//           withCredentials: true,
//         }
//       );
//       setTransactions(response.data.transactions);
//     } catch (err) {
//       setError("Failed to fetch transactions");
//       console.error(err);
//     }
//   };

//   useEffect(() => {
//     fetchOrganizations();
//   }, []);

//   useEffect(() => {
//     if (formData.organization_id) {
//       fetchProjects(formData.organization_id);
//       fetchOrgBalance(formData.organization_id);
//       fetchTransactions(formData.organization_id);
//     }
//   }, [formData.organization_id]);

//   const handleRecharge = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setError("");
//     setSuccess("");

//     try {
//       await axios.post(`${BASE_URL}/points/recharge`, formData, {
//         withCredentials: true,
//       });
//       setSuccess("Credits added successfully!");
//       setResponseMessage("Credits added successfully!");
//       setResponseType("success");
//       fetchOrgBalance(formData.organization_id);
//       fetchTransactions(formData.organization_id);
//       setFormData((prev) => ({
//         ...prev,
//         amount: "",
//         project_id: "",
//       }));
//     } catch (err) {
//       setError("Failed to add credits");
//       setResponseMessage("Failed to add credits");
//       setResponseType("error");
//       console.error(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <CssVarsProvider>
//       <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white p-4 md:p-8">
//         <div className="max-w-6xl mx-auto">
//           <header className="bg-white shadow-sm rounded-lg mb-8">
//             <div className="max-w-7xl mx-auto px-6 py-8">
//               <h1 className="text-3xl font-bold text-gray-900">
//                 Credit Management System
//               </h1>
//             </div>
//           </header>

//           {error && (
//             <Alert color="danger" className="mb-4">
//               {error}
//             </Alert>
//           )}

//           {success && (
//             <Alert color="success" className="mb-4">
//               {success}
//             </Alert>
//           )}

//           <div className="grid md:grid-cols-3 gap-8">
//             <Card className="md:col-span-2 p-6" variant="outlined">
//               <Typography level="h4" className="mb-6">
//                 Add Credits
//               </Typography>

//               <form onSubmit={handleRecharge} className="space-y-6">
//                 <FormControl>
//                   <FormLabel>Organization</FormLabel>
//                   <Select
//                     placeholder="Choose an organization"
//                     value={formData.organization_id}
//                     onChange={(_, value) =>
//                       setFormData({ ...formData, organization_id: value })
//                     }
//                     startDecorator={
//                       <Building2 className="text-blue-500" size={20} />
//                     }
//                     required
//                   >
//                     {organizations.map((org) => (
//                       <Option key={org.id} value={org.id}>
//                         {org.org_name}
//                       </Option>
//                     ))}
//                   </Select>
//                 </FormControl>

//                 <FormControl>
//                   <FormLabel>Project</FormLabel>
//                   <Select
//                     placeholder="Select project"
//                     value={formData.project_id}
//                     onChange={(_, value) =>
//                       setFormData({ ...formData, project_id: value })
//                     }
//                     startDecorator={
//                       <Building2 className="text-blue-500" size={20} />
//                     }
//                     required
//                   >
//                     {projects.map((project) => (
//                       <Option key={project.id} value={project.id}>
//                         {project.project_name}
//                       </Option>
//                     ))}
//                   </Select>
//                 </FormControl>

//                 <FormControl>
//                   <FormLabel>Credit Amount</FormLabel>
//                   <Input
//                     startDecorator={
//                       <Wallet className="text-blue-500" size={20} />
//                     }
//                     placeholder="Enter amount"
//                     type="number"
//                     value={formData.amount}
//                     onChange={(e) =>
//                       setFormData({ ...formData, amount: e.target.value })
//                     }
//                     required
//                   />
//                 </FormControl>

//                 <Button
//                   type="submit"
//                   loading={loading}
//                   size="lg"
//                   className="w-full bg-blue-600 hover:bg-blue-700"
//                   startDecorator={<Plus size={20} />}
//                 >
//                   Add Credits
//                 </Button>
//               </form>
//             </Card>

//             <div className="space-y-6">
//               {orgBalance && (
//                 <Card variant="outlined" className="p-6">
//                   <Typography level="h4" className="mb-4">
//                     Organization Balance
//                   </Typography>
//                   <div className="space-y-4">
//                     <div className="p-4 bg-blue-50 rounded-lg">
//                       <Typography level="body-lg" className="text-blue-800">
//                         {orgBalance.organization.org_name}
//                       </Typography>
//                       <Typography level="h3" className="text-blue-900">
//                         {orgBalance.organization.points_balance} Credits
//                       </Typography>
//                     </div>

//                     {orgBalance.projects.map((project) => (
//                       <div
//                         key={project.project_id}
//                         className="p-4 bg-gray-50 rounded-lg"
//                       >
//                         <Typography level="body-md">
//                           {project.project_name}
//                         </Typography>
//                         <div className="grid grid-cols-2 gap-2 mt-2">
//                           <div>
//                             <Typography
//                               level="body-xs"
//                               className="text-gray-600"
//                             >
//                               Total
//                             </Typography>
//                             <Typography level="body-md">
//                               {project.total_points}
//                             </Typography>
//                           </div>
//                           <div>
//                             <Typography
//                               level="body-xs"
//                               className="text-gray-600"
//                             >
//                               Available
//                             </Typography>
//                             <Typography level="body-md">
//                               {project.remaining_points}
//                             </Typography>
//                           </div>
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 </Card>
//               )}

//               <Button
//                 variant="outlined"
//                 color="neutral"
//                 className="w-full"
//                 startDecorator={<History size={20} />}
//                 onClick={() => setShowTransactions(true)}
//               >
//                 View Transaction History
//               </Button>
//             </div>
//           </div>

//           <Modal
//             open={showTransactions}
//             onClose={() => setShowTransactions(false)}
//           >
//             <ModalDialog size="lg">
//               <Typography level="h4" className="mb-4">
//                 Transaction History
//               </Typography>
//               <div className="max-h-[70vh] overflow-auto">
//                 <Table>
//                   <thead>
//                     <tr>
//                       <th>Date</th>
//                       <th>Type</th>
//                       <th>Amount</th>
//                       <th>Project</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {transactions.map((transaction) => (
//                       <tr key={transaction.id}>
//                         <td>
//                           {format(
//                             new Date(transaction.created_at),
//                             "MMM dd, yyyy HH:mm"
//                           )}
//                         </td>
//                         <td className="flex items-center gap-2">
//                           {transaction.transaction_type === "recharge" ? (
//                             <>
//                               <ArrowUpCircle
//                                 className="text-green-500"
//                                 size={16}
//                               />
//                               <span className="text-green-600">Recharge</span>
//                             </>
//                           ) : (
//                             <>
//                               <ArrowDownCircle
//                                 className="text-red-500"
//                                 size={16}
//                               />
//                               <span className="text-red-600">Deduction</span>
//                             </>
//                           )}
//                         </td>
//                         <td>{transaction.amount}</td>
//                         <td>Project {transaction.project_id}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </Table>
//               </div>
//               <Button
//                 className="mt-4"
//                 onClick={() => setShowTransactions(false)}
//               >
//                 Close
//               </Button>
//             </ModalDialog>
//           </Modal>
//         </div>
//         {showModal && (
//           <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//             <div className="bg-white rounded-lg p-8 max-w-md w-full mx-4">
//               <div className="flex justify-between items-center mb-6">
//                 <Typography
//                   level="h5"
//                   component="h3"
//                   className="text-xl font-semibold text-gray-900"
//                 >
//                   {responseType === "success" ? "Success!" : "Error"}
//                 </Typography>
//                 <Button onClick={() => setShowModal(false)} variant="plain">
//                   <X className="h-6 w-6 text-gray-400 hover:text-gray-500" />
//                 </Button>
//               </div>
//               <div className="flex items-center justify-center mb-6">
//                 <div
//                   className={`rounded-full p-3 ${
//                     responseType === "success" ? "bg-green-100" : "bg-red-100"
//                   }`}
//                 >
//                   {responseType === "success" ? (
//                     <CheckCircle className="h-8 w-8 text-green-500" />
//                   ) : (
//                     <AlertCircle className="h-8 w-8 text-red-500" />
//                   )}
//                 </div>
//               </div>
//               <Typography
//                 level="body1"
//                 className="text-center text-gray-600 mb-6"
//               >
//                 {responseMessage}
//               </Typography>
//               <Button
//                 fullWidth
//                 onClick={() => setShowModal(false)}
//                 color="primary"
//               >
//                 {responseType === "success" ? "Close" : "Try Again"}
//               </Button>
//             </div>
//           </div>
//         )}
//       </div>
//     </CssVarsProvider>
//   );
// }

// export default CreditPage;

import React, { useState, useEffect } from 'react';
import { format } from 'date-fns';
import axios from 'axios';
import { 
  Wallet, 
  Building2, 
  Plus, 
  History, 
  X, 
  ArrowUpCircle, 
  ArrowDownCircle,
  XCircle,
  CheckCircle,
  AlertCircle,
  Filter
} from 'lucide-react';

const CreditPage = () => {

  const [organizations, setOrganizations] = useState([]);
  const [orgBalance, setOrgBalance] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [selectedOrgId, setSelectedOrgId] = useState('');
  const [showTransactions, setShowTransactions] = useState(false);
  const [responseMessage, setResponseMessage] = useState('');
  const [responseType, setResponseType] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [transactionFilter, setTransactionFilter] = useState('all');
  const [formData, setFormData] = useState({
    amount: '',
    organization_id: '',
    user_id: 10, // Default user ID
  });

  const BASE_URL = process.env.REACT_APP_BASE_URL;

  // API calls
  const fetchOrganizations = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/orgdetails/getorganizations`);
      setOrganizations(response.data);
    } catch (error) {
      handleError('Failed to fetch organizations');
    }
  };

  const fetchOrgBalance = async (orgId) => {
    try {
      const response = await axios.post(`${BASE_URL}/points/balance/${orgId}`);
      setOrgBalance(response.data);
    } catch (error) {
      handleError('Failed to fetch organization balance');
    }
  };

  const fetchTransactions = async (orgId) => {
    try {
      const response = await axios.get(`${BASE_URL}/points/transactions/${orgId}`);
      setTransactions(response.data.transactions);
    } catch (error) {
      handleError('Failed to fetch transactions');
    }
  };

  const handleRecharge = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await axios.post(`${BASE_URL}/points/recharge`, formData);
      handleSuccess(response.data.message);
      setFormData(prev => ({ ...prev, amount: '' }));
      fetchOrgBalance(formData.organization_id);
      fetchTransactions(formData.organization_id);
    } catch (error) {
      handleError('Failed to add credits');
    } finally {
      setIsLoading(false);
    }
  };

  // Effects
  useEffect(() => {
    fetchOrganizations();
  }, []);

  useEffect(() => {
    if (selectedOrgId) {
      fetchOrgBalance(selectedOrgId);
      fetchTransactions(selectedOrgId);
    }
  }, [selectedOrgId]);

  // Event handlers
  const handleOrganizationChange = (e) => {
    const orgId = e.target.value;
    setSelectedOrgId(orgId);
    setFormData(prev => ({ ...prev, organization_id: orgId }));
  };

  const handleSuccess = (message) => {
    setResponseMessage(message);
    setResponseType('success');
    setShowModal(true);
  };

  const handleError = (message) => {
    setResponseMessage(message);
    setResponseType('error');
    setShowModal(true);
  };

  const filteredTransactions = transactionFilter === 'all'
    ? transactions
    : transactions.filter(t => t.transaction_type === transactionFilter);

  // Component rendering
  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white">
      <div className="container mx-auto px-4 py-8">
        {/* Header */}
        <div className="bg-white shadow-sm rounded-lg">
          <div className="max-w-7xl mx-auto px-6 py-6">
            <h1 className="text-3xl font-bold text-gray-900">
              Credit Management System
            </h1>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mt-8">
          {/* Recharge Form */}
          <div className="md:col-span-2">
            <div className="bg-white rounded-xl shadow-sm p-6 transition-all duration-300 hover:shadow-md">
              <h2 className="text-2xl font-semibold text-gray-800 mb-6 flex items-center">
                <Wallet className="mr-2 text-blue-600" size={24} />
                Add Credits
              </h2>
              
              <form onSubmit={handleRecharge} className="space-y-6">
                <div className="space-y-2">
                  <label htmlFor="organization_id" className="block text-sm font-medium text-gray-700">
                    Organization
                  </label>
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <Building2 className="h-5 w-5 text-gray-400" />
                    </div>
                    <select
                      id="organization_id"
                      value={formData.organization_id}
                      onChange={handleOrganizationChange}
                      className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                      required
                    >
                      <option value="">Select an organization</option>
                      {organizations.map(org => (
                        <option key={org.id} value={org.id}>
                          {org.org_name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="space-y-2">
                  <label htmlFor="amount" className="block text-sm font-medium text-gray-700">
                    Credit Amount
                  </label>
                  <div className="relative mt-1 rounded-md shadow-sm">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <Wallet className="h-5 w-5 text-gray-400" />
                    </div>
                    <input
                      type="number"
                      id="amount"
                      value={formData.amount}
                      onChange={(e) => setFormData(prev => ({ ...prev, amount: e.target.value }))}
                      className="block w-full pl-10 pr-12 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                      placeholder="0"
                      required
                      min="1"
                    />
                    <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                      <span className="text-gray-500 sm:text-sm">Credits</span>
                    </div>
                  </div>
                </div>

                <button
                  type="submit"
                  disabled={isLoading}
                  className={`w-full flex justify-center items-center py-2.5 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-200 ${
                    isLoading ? 'opacity-75 cursor-not-allowed' : ''
                  }`}
                >
                  {isLoading ? (
                    <>
                      <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      Processing...
                    </>
                  ) : (
                    <>
                      <Plus className="mr-2" size={18} />
                      Add Credits
                    </>
                  )}
                </button>
              </form>
            </div>
          </div>

          {/* Balance Card */}
          <div className="space-y-6">
            <div className="bg-white rounded-xl shadow-sm p-6 transition-all duration-300 hover:shadow-md">
              <h2 className="text-2xl font-semibold text-gray-800 mb-6 flex items-center">
                <Wallet className="mr-2 text-blue-600" size={24} />
                Organization Balance
              </h2>

              {isLoading ? (
                <div className="animate-pulse">
                  <div className="h-6 bg-gray-200 rounded w-3/4 mb-4"></div>
                  <div className="h-12 bg-gray-200 rounded w-1/2"></div>
                </div>
              ) : !orgBalance ? (
                <p className="text-gray-500 text-center py-8">
                  Select an organization to view balance
                </p>
              ) : (
                <div className="bg-gradient-to-r from-blue-500 to-blue-600 rounded-lg p-5 text-white">
                  <p className="text-blue-100 text-sm mb-1">Available Balance</p>
                  <div className="flex items-end">
                    <span className="text-3xl font-bold">{orgBalance.points_balance}</span>
                    <span className="ml-2 text-blue-100">Credits</span>
                  </div>
                </div>
              )}

              <button
                onClick={() => setShowTransactions(true)}
                className="w-full mt-6 flex justify-center items-center py-2.5 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-200"
              >
                <History className="mr-2" size={18} />
                View Transaction History
              </button>
            </div>
          </div>
        </div>

        {/* Transaction History Modal */}
        {showTransactions && (
          <div className="fixed inset-0 z-50 overflow-y-auto bg-black bg-opacity-50 flex items-center justify-center p-4">
            <div className="relative bg-white rounded-xl shadow-xl w-full max-w-4xl max-h-[90vh] flex flex-col animate-fadeIn">
              <div className="flex justify-between items-center p-6 border-b">
                <h2 className="text-2xl font-semibold text-gray-800">Transaction History</h2>
                <button
                  onClick={() => setShowTransactions(false)}
                  className="text-gray-400 hover:text-gray-500 transition-colors duration-200"
                >
                  <XCircle size={24} />
                </button>
              </div>

              <div className="p-4 border-b">
                <div className="flex items-center gap-2">
                  <Filter size={18} className="text-gray-500" />
                  <span className="text-sm font-medium text-gray-700">Filter:</span>
                  <div className="flex space-x-2">
                    <button
                      className={`px-3 py-1 rounded-full text-sm ${
                        transactionFilter === 'all'
                          ? 'bg-blue-100 text-blue-800'
                          : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                      } transition-colors duration-200`}
                      onClick={() => setTransactionFilter('all')}
                    >
                      All
                    </button>
                    <button
                      className={`px-3 py-1 rounded-full text-sm flex items-center ${
                        transactionFilter === 'recharge'
                          ? 'bg-green-100 text-green-800'
                          : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                      } transition-colors duration-200`}
                      onClick={() => setTransactionFilter('recharge')}
                    >
                      <ArrowUpCircle size={14} className="mr-1" />
                      Recharges
                    </button>
                    <button
                      className={`px-3 py-1 rounded-full text-sm flex items-center ${
                        transactionFilter === 'deduction'
                          ? 'bg-red-100 text-red-800'
                          : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                      } transition-colors duration-200`}
                      onClick={() => setTransactionFilter('deduction')}
                    >
                      <ArrowDownCircle size={14} className="mr-1" />
                      Deductions
                    </button>
                  </div>
                </div>
              </div>

              <div className="flex-grow overflow-auto p-4">
                {filteredTransactions.length === 0 ? (
                  <div className="flex flex-col items-center justify-center h-64 text-gray-500">
                    <p>No transactions found</p>
                  </div>
                ) : (
                  <div className="grid gap-3">
                    {filteredTransactions.map(transaction => (
                      <div
                        key={transaction.id}
                        className="bg-white border rounded-lg p-4 hover:shadow-sm transition-shadow duration-200"
                      >
                        <div className="flex justify-between items-start">
                          <div className="flex items-center">
                            {transaction.transaction_type === 'recharge' ? (
                              <div className="bg-green-100 p-2 rounded-full mr-3">
                                <ArrowUpCircle className="text-green-600" size={20} />
                              </div>
                            ) : (
                              <div className="bg-red-100 p-2 rounded-full mr-3">
                                <ArrowDownCircle className="text-red-600" size={20} />
                              </div>
                            )}
                            <div>
                              <p className="font-medium text-gray-900">
                                {transaction.transaction_type === 'recharge' ? 'Credit Recharge' : 'Credit Deduction'}
                              </p>
                              <p className="text-sm text-gray-500">
                                {format(new Date(transaction.created_at), 'MMM dd, yyyy HH:mm')}
                              </p>
                              {transaction.project_id && (
                                <p className="text-xs text-gray-500 mt-1">
                                  Project ID: {transaction.project_id}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className={`text-lg font-semibold ${
                            transaction.transaction_type === 'recharge'
                              ? 'text-green-600'
                              : 'text-red-600'
                          }`}>
                            {transaction.transaction_type === 'recharge' ? '+' : '-'}
                            {transaction.amount}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <div className="p-4 border-t">
                <button
                  onClick={() => setShowTransactions(false)}
                  className="w-full py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Response Modal */}
        {showModal && (
          <div className="fixed inset-0 z-50 overflow-y-auto bg-black bg-opacity-50 flex items-center justify-center p-4">
            <div className="relative bg-white rounded-xl shadow-xl w-full max-w-md p-6 transform transition-all duration-300 ease-out animate-fadeInUp">
              <div className="flex justify-end">
                <button
                  onClick={() => setShowModal(false)}
                  className="text-gray-400 hover:text-gray-500 transition-colors duration-200"
                >
                  <X size={20} />
                </button>
              </div>
              
              <div className="flex flex-col items-center mb-6">
                <div className={`p-3 rounded-full mb-4 ${
                  responseType === 'success' ? 'bg-green-100' : 'bg-red-100'
                }`}>
                  {responseType === 'success' ? (
                    <CheckCircle className="h-8 w-8 text-green-500" />
                  ) : (
                    <AlertCircle className="h-8 w-8 text-red-500" />
                  )}
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-1">
                  {responseType === 'success' ? 'Success!' : 'Error'}
                </h3>
                <p className="text-center text-gray-600">{responseMessage}</p>
              </div>
              
              <button
                onClick={() => setShowModal(false)}
                className={`w-full py-2.5 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white ${
                  responseType === 'success'
                    ? 'bg-green-600 hover:bg-green-700 focus:ring-green-500'
                    : 'bg-blue-600 hover:bg-blue-700 focus:ring-blue-500'
                } focus:outline-none focus:ring-2 focus:ring-offset-2 transition-colors duration-200`}
              >
                {responseType === 'success' ? 'Continue' : 'Try Again'}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CreditPage;
